import { css } from '@emotion/css'
import {
  CircularProgress,
  CircularProgressProps,
  SxProps,
  useTheme,
} from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { observer } from 'mobx-react'
import React from 'react'
import { loaderStyles } from './loaderStyles'

type LoaderProps = CircularProgressProps & {
  fullPage?: boolean
  containerSx?: SxProps
}

function Loader(props: LoaderProps) {
  const { fullPage, containerSx, ...otheProps } = props
  const theme = useTheme()
  const classes = loaderStyles(theme)

  return fullPage ? (
    <Backdrop open sx={classes.backdrop}>
      <div style={classes.root}>
        <CircularProgress
          variant='determinate'
          sx={classes.bottom}
          size={otheProps.size || 40}
          thickness={4}
          {...otheProps}
          value={100}
        />
        <CircularProgress
          variant='indeterminate'
          disableShrink
          sx={{ ...classes.top, animationDuration: '367ms' }}
          classes={{
            circle: classes.circle as string, // Приводим тип к string если необходимо
          }}
          size={otheProps.size || 40}
          thickness={4}
          {...otheProps}
        />
      </div>
    </Backdrop>
  ) : (
    <div style={{ position: 'relative', zIndex: 1501 }}>
      <CircularProgress
        variant='determinate'
        sx={{ color: '#EAEAEA' }}
        size={props.size || 40}
        thickness={props.thickness || 4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={{
          animationDuration: '367ms',
          color: (t) => t.palette.primary.main,
          position: 'absolute',
          left: 0,
        }}
        classes={{
          circle: css({
            strokeLinecap: 'round',
          }),
        }}
        size={props.size || 40}
        thickness={props.thickness || 4}
        {...props}
      />
    </div>
  )
}

export default observer(Loader)
